import { useRecoilState, useResetRecoilState } from "recoil";
import { ocRoleFiltersState } from "states";

export const useOcRoleFilter = (id: string) => {
  const [roleFilters, setRoleFilters] = useRecoilState(ocRoleFiltersState(id));
  const reset = useResetRecoilState(ocRoleFiltersState(id));

  return {
    roleFilters,
    setRoleFilters,
    reset,
  };
};
